import {DataService} from '../Services/data.service';
import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {Router} from '@angular/router';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})

export class LogoutComponent implements OnInit {

  constructor(private dataService: DataService, private location: Location, private router: Router) {
  }

  /**
   * onInit Logout
   */
  ngOnInit() {
    this.logout();
  }

  /**
   * Logout will unset user in the {@link DataService}
   * After setting all variables to null, user will be redirected to login screen
   */
  private logout(): void {
    this.dataService.logout().then(() => {
      this.router.navigateByUrl('');
    }).catch(() => {
      this.router.navigateByUrl('');
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/logout/logout.component.ts